import React, { useRef, useEffect, useState } from "react";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const [expandedCards, setExpandedCards] = useState([]);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setVisibleCards((prev) => [...prev, index]);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentCards = cardsRef.current;
    currentCards.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      currentCards.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const toggleExpanded = (index) => {
    setExpandedCards((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const resumeData = [
    {
      title: "Software Analyst",
      subTitle: "weDevs Ltd | Jun 2022 – present | Mirpur DOHS, Dhaka",
      responsibilities: [
        "Led product lifecycle management for a core SaaS product, increasing feature adoption by 35%.",
        "Accelerated feature delivery velocity by 500% (from 2-3 to 14-16 features annually) by optimizing Agile (Scrum) workflows.",
        "Engineered and integrated AI-powered text generation (OpenAI GPT & Google Gemini APIs) into the Dokan multivendor e-commerce plugin.",
        "Directed WordPress plugin and theme development lifecycles, including compatibility testing and API integration.",
        "Developed data-informed product roadmaps, translating objectives into detailed technical specifications.",
      ],
    },
    {
      title: "UI / UX & Frontend Developer",
      subTitle: "Lazychat Interactive | Sep 2021 – Jan 2022 | Gulshan 1, Dhaka",
      responsibilities: [
        "Spearheaded UX design and frontend development (React, Bootstrap) for responsive web applications using Figma.",
        "Architected a comprehensive UI design system for an e-commerce ecosystem (admin dashboard, food delivery, omnichannel interface).",
      ],
    },
    {
      title: "Game Writer",
      subTitle:
        "Battery Low Interactive | Jan 2021 – Oct 2022 | Baridhara, Dhaka",
      responsibilities: [
        "Developed engaging game design documents (GDDs), character mechanics, and narrative structures.",
        "Conducted market analysis and competitive research for player preferences.",
      ],
    },
    {
      title: "Subject Matter Expert (SME) - Wordpress Project",
      subTitle: "10 Minute School | 2024",
      responsibilities: [
        'Collaborated on course content creation and review for "Freelancing with Wordpress."',
      ],
    },
  ];

  return (
    <div className="w-full flex flex-col gap-12">
      <div className="w-full border-l-[2px] border-[#8A00D4] flex flex-col">
        {resumeData.map((item, index) => (
          <div
            key={index}
            ref={(el) => (cardsRef.current[index] = el)}
            data-index={index}
            className="opacity-0 transform translate-y-[30px] transition-all duration-700 mb-12"
            style={{
              opacity: visibleCards.includes(index) ? 1 : 0,
              transform: visibleCards.includes(index)
                ? "translateY(0)"
                : "translateY(30px)",
              transitionDelay: `${index * 150}ms`,
            }}
          >
            <ResumeCard
              title={item.title}
              subTitle={item.subTitle}
              responsibilities={item.responsibilities}
              isExpanded={expandedCards.includes(index)}
              toggleExpand={() => toggleExpanded(index)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
